import { PageContent } from '@/components/layout/page-content'
import { PageHeader } from '@/components/layout/page-header'
import { PageLayout } from '@/components/layout/page-layout'
import { TableInfo } from '@/components/tables/table'
import type { Request } from '@/types/requests/request'
import type { TableConfig } from '@/types/table/table-config'
import { useMyReviewsExternalTransfer } from './hooks/use-my-reviews-external-transfer'

export const MyReviewsExternalTransfer = () => {
  const {
    states: { data, isLoading },
    actions: { createTable }
  } = useMyReviewsExternalTransfer()

  const tableConfig: TableConfig<Request> = createTable(data?.data)

  return (
    <PageLayout isLoading={isLoading} loadingText="Carregando Análises">
      <PageHeader title="Minhas Análises" breadcrumb />
      <PageContent>
        <TableInfo<Request>
          paginationData={data?.pagination}
          withFilters={true}
          tableConfig={tableConfig}
          isLoading={isLoading}
        />
      </PageContent>
    </PageLayout>
  )
}
